var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GridPage',{ref:"gridPage",attrs:{"form-default":{
            boxes: [],
            items: [],
            attributes: {
                is_ignitability: false,
            },
            status: 'suspended',
            _no_importer: false,
        },"filters-default":{
            shipping_courier: 'dhl,shipper_maker,ups,fedex',
            created_at: '',
            sort: '-created_at',
        },"filter-items":[
            {
                vModel: 'created_at',
                title: '作成日',
                type: 'date-range',
                options: {
                    force_range: false,
                },
            },
            {
                vModel: 'sort',
                title: '順番',
                options: [
                    { text: '▲ 作成日', value: 'created_at', },
                    { text: '▼ 作成日', value: '-created_at' } ],
            } ],"filters-q-placeholder":"発送人氏名、発送人電話、発送人メール、Tuskey発送番号（#数字）","form-modal-id":"shipping","search-action":"shipping/index","filter-search-results":_vm.filterSearchResults,"row-class":"flex-nowrap mx-0 my--2","hide-download":false,"hide-table":true,"open-detail-after-saving":false,"item-id":"id"},on:{"after-save":_vm.afterSave,"after-destroy":_vm.afterDestroy},scopedSlots:_vm._u([{key:"form",fn:function(ref){
        var form = ref.form;
        var init = ref.init;
return [_c('Shipping',{attrs:{"model":form,"init":init},on:{"save":_vm.$refs.gridPage.save,"destroy":_vm.$refs.gridPage.destroy}})]}},{key:"before-filter",fn:function(){return undefined},proxy:true},{key:"after-table",fn:function(){return [_c('ShippingTable',{ref:"table",attrs:{"mode":"read"},on:{"on-detail":_vm.onDetail,"after-destroy":_vm.afterDestroy}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }